const state = {
  isTableEditingMode: false
}

const mutations = {
  'SET_TABLE_EDITING_MODE' (state, status) {
    state.isTableEditingMode = status
  }
}

export default {
  state,
  mutations
}
